import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { useClientStore } from '@/client/stores/client';
import { ServiceRequestsListResponse } from '@/client/types/service-requests';
import { withErrorHandling } from '@/client/utils/errors';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

type QueryResponse = ServiceRequestsListResponse['data'];

const useGetQueryFn = () => {
  const request = useClientStore(state => state.request)

  const queryFn = withErrorHandling(
    async (page: number = 1, additional = {}): Promise<QueryResponse> => {
      const rawParams = { page, ...additional };

      const params: Record<string, string> = Object.entries(rawParams).reduce((acc, [key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          acc[key] = String(value);
        }
        return acc;
      }, {} as Record<string, string>);
  
      const searchParams = new URLSearchParams(params);
      const url = `/api/v2/admin/service-request/list?${searchParams.toString()}`;
  
      const response = await request<ServiceRequestsListResponse>(url);
      return response.data;
    },
    'An unexpected error occurred while fetching service requests',
  );

  return queryFn;
}

export const createServiceRequestKey = ( page: number, additional: any[] = []) => [
  'service-requests',
  page,
  ...additional,
];

export const useServiceRequestsQuery = ( page = 1, additionalProps = {}) => {
  const queryFn = useGetQueryFn();

  return useQuery({
    queryKey: createServiceRequestKey( page, [additionalProps]),
    queryFn: () => queryFn(page, additionalProps),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
  });
};